import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  title: '100 Ready-to-Use Dance Fitness Class Ideas',
  value: '$12',
  description: '100 creative class ideas to keep every session fresh, engaging, and exciting throughout the entire year. Includes themed classes, creative combinations, musical concepts, partner activities, interval formats, cardio challenges, seasonal workouts, and more.',
  benefit: 'Never run out of ideas again. Open it, pick a concept, teach it.'
}, {
  title: '50 Complete Dance Fitness Class Plans',
  value: '$12',
  description: '50 fully structured lesson plans with objectives, complete flow, warm-up suggestions, choreography sections, intensity progression, transitions, coaching tips, cooldown structure, timing, and instructor notes.',
  benefit: 'Simply open the lesson plan, follow the structure, and teach.'
}, {
  title: '365 Warm-Ups, Cool-Downs & Movement Combinations',
  value: '$10',
  description: 'A complete library of dynamic activation sequences, mobility routines, coordination drills, flexibility exercises, recovery movements, rhythm transitions, dance combinations, and class-opening ideas.',
  benefit: 'Mix, match, and build fresh classes in minutes — every time.'
}, {
  title: 'Dance Fitness Monthly Challenges',
  value: '$12',
  description: 'Professionally designed monthly fitness challenges that encourage consistency, participation, goal setting, community engagement, and long-term motivation.',
  benefit: 'Transform occasional students into loyal, long-term members.'
}, {
  title: 'Dance Fitness Instructor Planner & Business Toolkit',
  value: '$12',
  description: 'Professional planning templates, class scheduling systems, attendance trackers, student progress sheets, goal planners, playlist organizers, marketing checklists, instructor worksheets, and productivity tools.',
  benefit: 'Spend less time managing. More time teaching unforgettable classes.'
}];
export function BonusSection() {
  return <section className="border-y border-charcoal-line bg-charcoal-card px-4 py-20 sm:py-24" data-id="element-15">
      <div className="mx-auto max-w-5xl" data-id="element-16">
        <header className="mb-12 text-center" data-id="element-17">
          <p className="text-xs font-bold uppercase tracking-[.18em] text-gold-light" data-id="element-18">
            Included at no extra cost
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-white sm:text-5xl" data-id="element-19">
            The 5 Strategic Bonuses
          </h2>
        </header>

        <div className="grid gap-5 md:grid-cols-2" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className={`relative rounded-2xl border border-gold/25 bg-charcoal p-7 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-21">
              <span className="absolute right-0 top-0 rounded-bl-xl border-b border-l border-gold/25 bg-gold/15 px-3 py-1.5 text-xs font-bold text-gold-light" data-id="element-22">
                BONUS {String(index + 1).padStart(2, '0')}
              </span>
              <GiftIcon className="mb-5 text-gold-light" size={28} data-id="element-23" />
              <h3 className="max-w-[80%] font-display text-xl font-bold text-white" data-id="element-24">
                {bonus.title}
              </h3>
              <p className="mt-3 text-xs text-zinc-400" data-id="element-25">
                Real Value: <s data-id="element-26">{bonus.value}</s>
                <b className="ml-2 text-gold-light" data-id="element-27">→ Yours FREE</b>
              </p>
              <p className="mt-4 text-sm leading-relaxed text-zinc-300" data-id="element-28">
                {bonus.description}
              </p>
              <p className="mt-5 text-sm font-semibold italic text-gold-light" data-id="element-29">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-gold/35 bg-gold/10 p-7 text-center" data-id="element-30">
          <p className="text-sm text-zinc-300" data-id="element-31">
            All 5 bonuses are included with your purchase today
          </p>
          <p className="mt-4 text-sm text-zinc-400" data-id="element-32">Your price today</p>
          <p className="mt-1 text-4xl font-bold text-gold-light" data-id="element-33">FREE</p>
          <p className="mt-3 text-xs text-zinc-400" data-id="element-34">
            Delivered with your complete teaching system.
          </p>
        </div>
        <CountdownTimer data-id="element-35" />
        <div className="mt-8 text-center" data-id="element-36">
          <CheckoutButton data-id="element-37">GET THE COMPLETE TEACHING SYSTEM NOW</CheckoutButton>
        </div>
      </div>
    </section>;
}